import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import SavingStates from "../../constants/states/SavingStates";
import EmailVerificationViewStore from "../../stores/EmailVerificationViewStore";
import EmailVerificationView from "../views/EmailVerificationView";
import PropTypes from "prop-types";


class EmailVerificationContainer extends React.Component {

    static propTypes = {
        email: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            "emailVerificationViewStoreState": EmailVerificationViewStore.getState()
        };
    }

    componentDidMount() {
        this.emailVerificationStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.EMAIL_VERIFICATION_VIEW_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.EMAIL_VERIFICATION_EMAIL_REQUESTED, {});
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.emailVerificationStoreSubscriber);
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "emailVerificationViewStoreState": EmailVerificationViewStore.getState()
        });
    };

    render() {
        return (
            <EmailVerificationView
                email={this.props.email}
                isCheckingCode={this.state.emailVerificationViewStoreState.codeCheckState === SavingStates.SAVING}
                isRequestingEmail={this.state.emailVerificationViewStoreState.emailSendState === SavingStates.SAVING}
                validationCode={this.state.emailVerificationViewStoreState.validationCode}
            />
        );
    }

}

export default EmailVerificationContainer;